



















import { ROUTER_CONSTS } from '../../router/router.consts';

import NavigationMenuItem from './navigation-menu-item.component.vue';

export default {
  name: 'navigation-menu-footer',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    collapsed: Boolean,
    animationDurationInMillis: Number
  },
  components: {
    NavigationMenuItem
  },
  data: function () {
    return {
      ROUTER_CONSTS
    };
  },
  methods: {
    getItemTransition: function (index: number) {
      const itemTransitionDurationInMillis = Math.min((this.animationDurationInMillis / (this.items.length + 1)), 200);
      return {
        durationInMillis: itemTransitionDurationInMillis,
        delayInMillis: (itemTransitionDurationInMillis * index)
      };
    }
  }
};

